import { useEffect } from 'react'
import gsap from 'gsap'

const useScrollHideContact = (
  contactRef: React.RefObject<HTMLDivElement>,
  containerRef: React.RefObject<HTMLDivElement>,
) => {
  useEffect(() => {
    const handleScroll = () => {
      if (!contactRef.current || !containerRef.current) return

      const contactElement = contactRef.current
      const containerElement = containerRef.current
      const containerRect = containerElement.getBoundingClientRect()

      if (window.innerWidth > 1024) {
        if (containerRect.bottom <= window.innerHeight) {
          gsap.to(contactElement, { duration: 0.5, x: 360, opacity: 0 })
        } else {
          gsap.to(contactElement, { duration: 0.5, x: 0, opacity: 1 })
        }
      } else {
        gsap.to(contactElement, { duration: 0.5, x: 0, opacity: 1 })
      }
    }

    const handleResize = () => {
      handleScroll()
    }

    window.addEventListener('scroll', handleScroll)
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('scroll', handleScroll)
      window.removeEventListener('resize', handleResize)
    }
  }, [contactRef, containerRef])
}

export default useScrollHideContact
